import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";

export default function ProductDescription({ title, link }) {
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [imgfile, setimgfile] = useState(null);
  const [imgdisplay, setimgdisplay] = useState(null);
  const [base64, setBase64] = useState("");
  const [trainload, setTrainload] = useState(false);
  const [description, setDescription] = useState("");
  const [additionalinfo, setAdditionalinfo] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const handleDescription = async () => {
    console.log("started");
    if (imgfile) {
      console.log("started2");
      // When the file is loaded, encode it to base64
      setTrainload(true);
      var data = JSON.stringify({
        imagedata: base64,
        additionalinfo: additionalinfo,
      });

      var xhr = new XMLHttpRequest();
      // xhr.withCredentials = true;
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          console.log(JSON.parse(this.responseText));
          // setDescription(this.responseText)
          setError("Description generated!");
          setTrainload(false);
          setDescription(JSON.parse(this.responseText));
        }
      });

      xhr.open(
        "POST",
        "https://pc46visgm6623p7csad5cafmhe0itkqk.lambda-url.ap-south-1.on.aws/",
      );

      xhr.send(data);
    } else {
      setError("please select image file.");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setimgfile(file);
    setError("");
    setimgdisplay(null);
    setAdditionalinfo("");
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      setBase64(base64String);
      setimgdisplay(reader.result);
    };
    reader.readAsDataURL(file);
  };
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                              <Button  variant="contained" color="primary" >Home</Button>
                          </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div className="emailsum-container">
          <div className="input-form-chatbot" style={{ flex: "0.4" }}>
            <p>
              <strong>Upload a product image to generate description:</strong>
            </p>
            <hr style={{ background: "white" }}></hr>
            {/* <p>Upload a product image to generate description:</p> */}
            <div>
              <input
                accept=".jpg"
                id="csv-upload"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <label htmlFor="csv-upload">
                <Button variant="contained" component="span">
                  Upload Product Image
                </Button>
              </label>
              <Typography variant="body1">
                {imgfile && `Selected file: ${imgfile.name}`}
              </Typography>

              <Button
                variant="contained"
                color="primary"
                component="span"
                style={{ color: "white" }}
                onClick={handleDescription}
                startIcon={
                  trainload && <CircularProgress color="white" size={20} />
                }
              >
                Generate Description
              </Button>
            </div>
            <br />
            {error}
            <br />
            <p>Enter additional information about the product:</p>
            <TextField
              fontColor="white"
              id="outlined-basic"
              style={{
                border: "1px solid white",
                borderRadius: "0.5rem",
                width: "100%",
              }}
              value={additionalinfo}
              onChange={(e) => {
                setAdditionalinfo(e.target.value);
              }}
              variant="outlined"
            />
            <br />
            <div>
              {imgdisplay && (
                <>
                  <p>Uploaded image:</p>
                  <img
                    style={{ width: "15rem" }}
                    src={imgdisplay}
                    alt="product image"
                  />
                </>
              )}
            </div>
          </div>
          <div
            className="input-form-chatbot"
            style={{ minHeight: "25rem", flex: "1.5rem" }}
          >
            {/* <h4>Generated Description</h4> */}
            <h3>
              <strong>Generated Product Description</strong>
            </h3>
            <hr style={{ background: "white" }}></hr>
            {description && (
              <TypeAnimation
                sequence={[description["content"][0]["text"]]}
                key={description["content"][0]["text"]}
                speed={100}
                cursor={false}
              />
            )}
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
